var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpgradeIonBarrier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 385.92 385.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: .3;\n      }\n\n      .cls-2 {\n        fill: #b1c69e;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M333.95,334.1c-22.18,22.18-50.57,35.91-81.24,39.57l12.24,12.24c9.91-2.04,19.6-5.05,29.01-9.03,18.53-7.84,35.16-19.05,49.44-33.33,14.28-14.28,25.5-30.92,33.33-49.44,4.08-9.64,7.14-19.57,9.18-29.74l-12.31-12.31c-3.52,30.98-17.29,59.66-39.66,82.04Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.55,0c-10.17,2.04-20.1,5.11-29.74,9.18-18.53,7.84-35.16,19.05-49.44,33.33-14.28,14.28-25.5,30.92-33.33,49.44-3.98,9.41-6.99,19.1-9.03,29.01l12.24,12.24c3.66-30.68,17.39-59.06,39.57-81.24,22.38-22.38,51.06-36.14,82.04-39.66L121.55,0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeIonBarrier);
export default __webpack_public_path__ + "static/media/upgrade-ion-barrier.990fb168d904629496feba39ce4f5525.svg";
export { ForwardRef as ReactComponent };